import React, {FC} from 'react';

import {Modal, zIndex} from '@optimaxdev/design-system';
import {Icon, File, Envelope, MoneyBackMini} from '@optimaxdev/icons';
import classNames from 'classnames';

import s from './rebatePopup.scss';

type PropsType = {
    isModalOpen: boolean;
    onClose: () => void;
};

const STEPS = [
    {
        description:
            'Once your order is shipped, we’ll email you a link to the rebate page\n' +
            'so you can print your form. ',
        iconsOptions: {
            height: 34,
            name: File,
            strokeWidth: 2,
            style: s.firstStepIcon,
        },
    },
    {
        description: 'Fill out the form and mail it to us.',
        iconsOptions: {
            height: 22,
            name: Envelope,
            strokeWidth: 2,
            style: s.secondStepIcon,
        },
    },
    {
        description:
            "The rebate will be applied to your payment method within 8 weeks after we've received your form.",
        iconsOptions: {
            height: 31,
            name: MoneyBackMini,
            strokeWidth: 1,
            style: s.thirdStepIcon,
        },
    },
];

/**
 * Rebate popup component
 */
export const RebatePopup: FC<PropsType> = ({isModalOpen, onClose}) => {
    return (
        <Modal
            isOpen={isModalOpen}
            onRequestClose={onClose}
            overlay="dark"
            zIndex={zIndex.tooltip}
            shouldCloseOnOverlayClick
        >
            <div className={s.container}>
                <div className={s.col}>
                    <div className={s.header}>
                        <Icon
                            className={s.headerIcon}
                            height={22}
                            icon={MoneyBackMini}
                            width={22}
                        />
                        <h2 className={s.title}>Rebate</h2>
                        <p className={s.titleAdd}>It&apos;s as easy as 1-2-3!</p>
                    </div>
                    <h4 className={s.subtitle}>Here’s how it works:</h4>
                    {STEPS.map(({description, iconsOptions}) => (
                        <div className={s.step} key={description}>
                            <div className={classNames(s.stepIcon, iconsOptions.style)}>
                                <Icon
                                    height={iconsOptions.height}
                                    icon={iconsOptions.name}
                                    strokeWidth={iconsOptions.strokeWidth}
                                />
                            </div>
                            <p className={s.stepDescription}>{description}</p>
                        </div>
                    ))}
                    <div className={s.linkWrap}>
                        <a className={s.link} href="/terms-and-conditions" target="_blank">
                            Terms and conditions
                        </a>
                    </div>
                </div>
                <div className={classNames(s.col, s.colBackground)} />
            </div>
        </Modal>
    );
};
